export default function ProductsDescription() {
  const products = [{
    title: "HSS",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/product_hss_structural.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/product_hss_structural.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/product_hss_structural.png-wvc-sizes",
      alt: "Perfil Estructural HSS"
    }
  }, {
    title: "Viga IPR",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/product_viga_ipr.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/product_viga_ipr.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/product_viga_ipr.png-wvc-sizes",
      alt: "Viga de Acero IPR"
    }
  }, {
    title: "Rejilla Irving",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/product_rejilla_irving.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/product_rejilla_irving.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1679911/img/product_rejilla_irving.png-wvc-sizes",
      alt: "Rejilla Industrial Irving"
    }
  }];
  return <section id="products-description" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="mb-16 md:mb-20">
          <p className="text-foreground/80 text-justify font-default text-base md:text-lg leading-relaxed">
            Se utilizan en la fabricación de estructuras metálicas para construcciones industriales, señalamientos, invernaderos, entre otras. Son elementos que forman la parte resistente de una construcción. El sistema estructural en acero se basa en un marco o esqueleto de cualquier estructura cuyos componentes en su mayoría son columnas y vigas de acero, estos elementos nos ayudan para soportar el suelo, techo y las paredes de un edificio. Los perfiles se nombran en forma abreviada usando su altura o peralte y su peso por unidad de longitud.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 md:gap-12">
          {products.map((product, i) => <div key={i} data-index={i} className="flex flex-col items-center group">
              <div className="w-full border border-border p-3 rounded-md shadow-sm bg-card transition-shadow duration-300 hover:shadow-md">
                <img src={product.image.src} data-wvc-srcset={product.image.srcset} data-wvc-sizes={product.image.sizes} alt={product.image.alt} className="w-full aspect-square object-cover rounded-sm" loading="lazy" />
              </div>
              <h3 className="mt-6 text-xl md:text-2xl font-semibold font-default text-foreground text-center">
                {product.title}
              </h3>
            </div>)}
        </div>
      </div>
    </section>;
}